export default {
    name: 'datetime',
    title: '日期时间',
    formName:'default',
    uniqid:'',
    label:'预约时间',
    type:'datetime',
    value:''
}